import { ColorRing } from "react-loader-spinner";
import { ICircleSpinnerLoader } from "../interface";
const CircleSpinnerLoader: React.FC<ICircleSpinnerLoader> = (props) => {
  return (
    <div className="flex justify-center">
      <ColorRing
        visible={true}
        height={props?.h}
        width={props?.w}
        ariaLabel="color-ring-loading"
        wrapperStyle={{}}
        wrapperClass="color-ring-wrapper"
        colors={["#e15b64", "#f47e60", "#f8b26a", "#abbd81", "#849b87"]}
      />
    </div>
  );
};
export default CircleSpinnerLoader;
